<script setup lang="ts">
import { useModalStore }             from "@TsStore/modalStore";
import type { ModalOptions, Modal }  from 'flowbite'
import { onMounted, onUpdated, ref } from "vue";

let ModalInstance : any | null = null,
    modal : Modal | null = null;

const modalStore = useModalStore(),
    targetEl = ref<HTMLElement | null>(null),
    modalOptions : ModalOptions = {
        onHide: () => {
            modalStore.resetModal();
        },
    },
    closeModal = () => modal && modal.hide();

const importModal = async () : Promise<void> => {
    if (!ModalInstance) {
        ModalInstance = (await import('flowbite/lib/esm/components/modal')).default;
    }
};

onMounted(async () => {
    if (modalStore.isOpen) {
        await importModal();
        modal = ModalInstance && (new ModalInstance(targetEl.value, modalOptions));

        modal && modal.show();
    }
});

onUpdated(async () => {
    if (modalStore.isOpen) {
        await importModal();
        modal = ModalInstance && (new ModalInstance(targetEl.value, modalOptions));

        modal && modal.show();
    }
});
</script>

<template>
    <div id="default-modal" tabindex="-1" aria-hidden="true" ref="targetEl"
         class="hidden overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full">
        <div class="relative p-4 w-full max-w-2xl max-h-full">
            <!-- Modal content -->
            <div class="relative bg-white rounded-lg shadow dark:bg-gray-700">
                <!-- Modal header -->
                <div class="flex items-center justify-between p-2 border-b rounded-t dark:border-gray-600">
                    <button type="button" class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
                            @click="closeModal">
                        <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
                            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
                        </svg>
                        <span class="sr-only">Close modal</span>
                    </button>
                </div>
                <!-- Modal body -->
                <div class="p-2 space-y-4">
                    <div class="bg-white px-1 py-2">
                        <div class="sm:flex sm:items-start">
                            <div class="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                                <p v-if="modalStore.isSuccessMessage" class="text-lg text-gray-600"
                                   v-html="modalStore.getSuccessMessage">
                                </p>

                                <p v-if="modalStore.isWarningMessage" class="text-lg text-gray-600"
                                   v-html="modalStore.getWarningMessage">
                                </p>

                                <p v-if="modalStore.isErrorMessage" class="text-lg text-gray-600"
                                   v-html="modalStore.getErrorMessage">
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Modal footer -->
                <div class="flex items-center p-2 border-t border-gray-200 rounded-b dark:border-gray-600">
                    <button type="button" @click="closeModal"
                            class="ml-auto rounded-md bg-green-300 hover:bg-green-100 px-3 py-2
                                text-sm font-semibold text-gray-900 ring-1 ring-inset ring-green-400 sm:mt-0 sm:w-auto">
                        Ok
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>

</style>
